import { DOMAINS_BY_COUNTRY } from '@front/common/src/constants/country';
import { getCurrentCountry } from '@front/common/src/utils/country';

// document.cookie works in a special way
// document.cookie = 'something=value'; will just append this cookie to the others
// thus, document.cookie = ''; will not reset cookies: we need to make them expire one by one
export const deleteAllCookies = () => {
  document.cookie.split(';').forEach((cookie) => {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });
};

export const getCookie = (name: string) => {
  const cookies = document.cookie.split('; ');
  const match = cookies.find((cookie) => {
    const [key] = cookie.split('=');
    return key === name;
  });
  if (!match) return undefined;
  return match.split('=')[1];
};

type SetCookieParams = {
  name: string;
  value: string;
  days?: number;
  domain?: string;
  path?: string;
};

export const setCookie = ({ name, value, days = 300, domain, path }: SetCookieParams) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  const domainString = domain || `.wecasa${DOMAINS_BY_COUNTRY[getCurrentCountry()]}`;
  document.cookie = `${name}=${value};${expires};domain=${domainString};path=${path || '/'};`;
};
